import { PageController } from '@client/components/_core/layout/PageController';
import { PublicComplaintForm } from '@client/components/complaints/PublicComplaintForm';
import { CONFIG_LOOKUP_QUERY_OPTIONS } from '@client/trpc/query-options';
import type { ShareableRouteContext } from '@client/types/router';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/public/$orgId/complaint/new')({
    beforeLoad: ({ context, params }): ShareableRouteContext => {
        // Runs concurrently with the parent route's org-settings prefetch — the two
        // used to be strictly serial (outlet gated on org settings, then the mounted
        // form fetched brand config). CUR-1036, task 2.1.
        void context.trpcUtils.complaint.getBrandConfig.prefetch(
            { orgId: params.orgId },
            { ...CONFIG_LOOKUP_QUERY_OPTIONS, meta: { errorSurface: 'silent', captureToSentry: false } },
        );
        return undefined;
    },
    component: ComplaintNewPage,
});

function ComplaintNewPage() {
    return (
        <PageController route={Route}>
            <PublicComplaintForm />
        </PageController>
    );
}
